import { usePage } from "@inertiajs/react";
import GoogleReviewsCarousel from "@/Components/GoogleReviewsCarousel";
import useIsMobile from "@/hooks/useIsMobile";
import React from "react";

// Real Google reviews, our own carousel (the Trustindex trial expired 2026-10).
// On /services/* pages the layout renders this once, right before the footer
// (`atPageEnd`); in-page copies there render nothing.
const GoogleReviewsMarquee = ({ atPageEnd = false }) => {
    const { url = "" } = usePage();
    const path = url.split("?")[0];
    if (!atPageEnd && decodeURIComponent(path).startsWith("/services/")) return null;
    // Mobile gets a smaller heading and cards; desktop keeps its exact classes.
    const m = useIsMobile();
    return (
        <div className={m ? "pt-3 pb-6" : "py-8 md:py-14 lg:py-16"}>
            <div className={`wrapper ${m ? "mb-4" : "mb-6 md:mb-10"} text-center`}>
                <h3 className={`${m ? "text-2xl mb-2" : "text-3xl md:text-4xl lg:text-5xl mb-5"} font-extrabold text-gray-900 tracking-tight text-balance`}>
                    آراء عملائنا على <span className="text-blue-600">Google</span>
                </h3>
                <p className={`max-w-[650px] mx-auto ${m ? "text-[13px] leading-[1.7]" : "text-base lg:text-lg leading-[1.8]"} text-gray-500 font-medium`}>
                    نحن فخورون بتقديم خدمات استثنائية تنال رضا عملائنا، إليك بعض مما قالوه عنا
                </p>
            </div>
            <div className="wrapper">
                <GoogleReviewsCarousel />
            </div>
        </div>
    );
};

export default GoogleReviewsMarquee;
